import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Zap } from "lucide-react";
import { scrollToSection } from "@/components/Reveal";

const LINKS = [
  ["Our Story", "#story", "nav-story-link"],
  ["Nonprofit", "#nonprofit", "nav-nonprofit-link"],
  ["Campus", "#campus", "nav-campus-link"],
  ["Get Involved", "#volunteer", "nav-volunteer-link"],
  ["Contact", "#contact", "nav-contact-link"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#08080C]/85 border-b border-[#242436]" data-testid="main-nav">
      <div className="px-4 sm:px-8 lg:px-16 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.webp"
            alt="G.A.M.E. Mentorship and Training Inc. logo"
            className="h-11 w-auto rounded-sm ring-1 ring-[#FFB800]/60 group-hover:ring-[#FFB800] transition-all duration-300"
          />
          <span className="hidden xl:block font-mono text-[10px] uppercase tracking-[0.2em] text-[#A1A1B3] leading-tight">
            Grind. Achieve.<br />Motivate. Excel.
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([label, id, tid]) => (
            <a
              key={id}
              href={id}
              onClick={(e) => go(e, id)}
              data-testid={tid}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#A1A1B3] hover:text-[#F4F4F6] transition-colors duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#8B5CF6] hover:after:w-full after:transition-[width] after:duration-300"
            >
              {label}
            </a>
          ))}
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="font-mono text-xs uppercase tracking-[0.2em] text-[#62627A] hover:text-[#FFB800] transition-colors duration-200"
          >
            Admin
          </Link>
          <button
            onClick={(e) => go(e, "#donate")}
            data-testid="nav-donate-link"
            className="bg-[#8B5CF6] text-black font-display font-800 font-extrabold uppercase tracking-wider text-sm px-6 py-2.5 flex items-center gap-2 hover:bg-[#FFB800] active:scale-95 transition-colors duration-200"
          >
            <Zap className="w-4 h-4" strokeWidth={2.5} />
            Donate Now
          </button>
        </nav>

        <button
          className="lg:hidden text-[#F4F4F6]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#242436] bg-[#08080C]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map(([label, id, tid]) => (
            <a
              key={id}
              href={id}
              onClick={(e) => go(e, id)}
              data-testid={`${tid}-mobile`}
              className="font-display font-bold uppercase tracking-wider text-xl text-[#F4F4F6]"
            >
              {label}
            </a>
          ))}
          <Link to="/admin" data-testid="nav-admin-link-mobile" className="font-mono text-xs uppercase tracking-[0.2em] text-[#62627A]">
            Admin
          </Link>
          <button
            onClick={(e) => go(e, "#donate")}
            data-testid="nav-donate-link-mobile"
            className="bg-[#8B5CF6] text-black font-display font-extrabold uppercase tracking-wider px-6 py-3 w-fit"
          >
            Donate Now
          </button>
        </div>
      )}
    </header>
  );
};
